import { formatDate } from '@travelata-libs/utils';
import Cookies from 'js-cookie';
import { useTravelataAppConfig } from '@/shared/composables';
import { LocalStorageKey } from '@/shared/config/localStorage';
import { abTests } from '@/shared/lib/AbTests';
import { GA_COOKIE, TRACKING_TIMESTAMP_FORMAT, YANDEX_METRIKA_COOKIE } from '../config';
import type { TrackingMeta, TrackingSource } from '../model/types';

interface TrackingMetaOptions {
  timestamp: number;
  customerHash: string | null;
}

function getTrackingSource(isMobileDomain: boolean | undefined): TrackingSource | null {
  if (isMobileDomain === undefined) return null;

  return isMobileDomain ? 'mobweb' : 'desktop';
}

export function getTrackingMeta({ timestamp, customerHash }: TrackingMetaOptions): TrackingMeta {
  const { isMobileDomain } = useTravelataAppConfig();

  return {
    ga_id: Cookies.get(GA_COOKIE) || 0,
    ya_id: Cookies.get(YANDEX_METRIKA_COOKIE) || 0,
    domain: window.location.host,
    source: getTrackingSource(isMobileDomain),
    timestamp: formatDate(timestamp, TRACKING_TIMESTAMP_FORMAT),
    ab_tests: abTests.getCookie(),
    customer_hash: customerHash,
  };
}

export function hasPersonalProfile(): boolean {
  try {
    const interests: unknown = JSON.parse(localStorage.getItem(LocalStorageKey.UserInterests) || 'null');

    return typeof interests === 'object' && interests !== null && Object.keys(interests).length > 0;
  } catch {
    return false;
  }
}
